import ConnectedAccounts from '@/settings/components/ConnectedAccounts'
import { SettingsPanelShell } from '../components/SettingsPanelShell'

/** Connected accounts section: the existing self-contained ConnectedAccounts component, unchanged. */
export function ConnectedAccountsPanel() {
  return (
    <SettingsPanelShell title="Connected accounts">
      <ConnectedAccounts />
    </SettingsPanelShell>
  )
}
